import * as React from 'react';
import {
  DETAIL_FIELDS,
  ALL_FIELDS,
  CDN_CLRSAVE_URL,
  KYCStatus,
  Direction,
  ERROR_MESSAGES,
} from '../constants';
import Field from '../components/ui/field';
import Button from './ui/button';
import cx from 'classnames';
import validate from '../utils/formValidator';
import KycError from './kycError';
import { addScriptDynamically, isObjectEmpty, showError } from '../utils';
// @ts-ignore
import { Router } from '../configs/routes';
import { UserEntity } from '../models/userdetails';
import { KYCStatusResponse } from '../models/KYCStatusResponse';
import { handleTrack, trackAction, trackPixel } from '../utils/trackActions';

import styles from '../styles/details.scss';
import PFSStyles from '../styles/plan/paymentFundsSummary.scss';
import commonStyles from '../styles/index.scss';

import { Api } from '../api';
import { createActivity } from '../utils/leadUtils';
import {
  BANK_CODES,
  DEFAULT_PAYMENT_MODES,
  RAZORPAY_PAYMENT_OPTIONS,
} from '../constants/bankCodes';
import { investFlowTrackActionData } from '../constants/trackActionConstants';
import {
  PAYMENT_GATEWAYS,
  RAZORPAY_OPTIONS,
  RAZORPAY_CHECKOUT_JS,
} from '../constants/payments';
import { CartResponse } from '../models/cart';
import Loader from './ui/Loader';
import FundList from './payment/fundList';
import { stringify } from 'query-string';
import PaymentFundsSummaryNew from './plan/paymentFundsSummaryNew';
import ScheduleLater from './common/scheduleLater';

export interface PersonalInfoProps {
  errors?: any;
  entity?: UserEntity;
  handleNavigation?(slug: string, to: string, event?: any): void;
  url?: any;
  className?: string;
  investmentType?: Direction;
  handleEditAmount?: any;
  onEditFunds?: any;
  hideEditFunds?: boolean;
  investmentOwnerCode?: string;
  toggleInvestmentOwnerCodeHasError?: (value: boolean) => void;
  investmentOwnerCodeHasError?: boolean;
  SipDateHasError?: boolean;
  toggleSIPDateSelectorHasError?: (value: boolean) => void;
  cart?: CartResponse;
  kycCheck?: any;
  handleBack?: () => string;
  isEditFromProfile?: boolean;
  personalDetailsUpdated?: () => void;
  doPennyDrop?: (userDetails: any, cb: any) => any;
  bankErrorMsg?: string;
  isBankVerified?: boolean;
  trackLabel?: string;
  userBankAccounts?: any;
  isPaymentMode?: boolean;
  sipDates: string[];
  personalDetails: object;
  handleInvestmentOwner: (e: React.FormEvent<HTMLSelectElement>) => void;
  bankDetails: Record<string, any>;
  selectedFund?: Record<string, any>;
  scheduleLater?: boolean;
  scheduleModal?: () => void;
  dissmissScheduleModal?: () => void;
  dismissModal?: () => void;
  pennyDropPending?: boolean;
  isOtpVerified?: boolean;
  showOtpScreen?: () => void;
  investmentToken?: string;
}

interface State {
  formValues: any[];
  detailsSlug?: string;
  entity: UserEntity | any;
  showNRIField: boolean;
  bankCode: string;
  ifscResponse: any;
  value: string;
  kycStatusResponse: KYCStatusResponse;
  billdeskResponse: any; // TODO match with billdeskResponse type
  pincodeResponse: any;
  hasUserInvested: boolean;
  skipUserDetails: boolean;
  isSubmiting: boolean;
  upiCheckbox: boolean;
  btnText: string;
  isNRI: boolean;
  bankErrMsg: string;
  userBankAccounts: Record<string, any>[];
  selectedBankAccId: number;
  selectedSipDate: number;
  scheduled: boolean;
  enableScheduleLater: boolean;
  selectedBankTpvData: Record<string, any>;
  isOtpAlreadyVerified: boolean;
  investmentToken?: string;
}

const api = new Api();
const { Component, Fragment } = React;
class DetailsFields extends Component<PersonalInfoProps, State> {
  private billdeskForm: HTMLFormElement;
  constructor(props: PersonalInfoProps) {
    super(props);
    this.state = {
      formValues: [],
      showNRIField: false,
      detailsSlug: props.url.query.detailsSlug || 'first',
      entity: {},
      bankCode: '',
      ifscResponse: '',
      value: '',
      kycStatusResponse: {} as KYCStatusResponse,
      billdeskResponse: null,
      pincodeResponse: {},
      hasUserInvested: false,
      skipUserDetails: false,
      isSubmiting: false,
      upiCheckbox: false,
      btnText: 'PROCEED TO PAY',
      isNRI: false,
      bankErrMsg: '',
      userBankAccounts: [],
      selectedBankAccId: 0,
      selectedSipDate: 15,
      scheduled: true,
      enableScheduleLater: false,
      selectedBankTpvData: null,
      isOtpAlreadyVerified: false,
      investmentToken: props.investmentToken || '',
    };
  }

  public async componentDidMount() {
    const {
      url: {
        query: { useRazorpay },
      },
      // cart,
    } = this.props;
    if (useRazorpay !== '1') {
      addScriptDynamically(`${RAZORPAY_CHECKOUT_JS}`);
    }

    this.handleScheduleBtn();
    /*
      // Invoke OTP screen for all folio(Existing or New)
    if (cart) {
      const productIds =
        (cart.items && cart.items.map((item) => item.product.id)) || [];
      const res = await api.requireInvestmentOtp(productIds);
      if (res && res.otpStatus === 'ALREADY_VERIFIED') {
        this.setState({
          isOtpAlreadyVerified: true,
          investmentToken: res.investmentToken,
        });
      }
    }
    */
    await this.updateStateFromProps();
  }

  public async setBankAcounts(): Promise<void> {
    const userBankAccounts = await api.getAllBankAccounts();
    const verifiedBankAccounts = userBankAccounts.filter(
      (bank) => bank.verified
    ); // To show only verified accounts
    let bankAccId = 0;
    if (verifiedBankAccounts.length > 0) {
      const primaryAcc = verifiedBankAccounts.filter((item) => item.primary);
      bankAccId =
        primaryAcc.length > 0 ? primaryAcc[0].id : verifiedBankAccounts[0].id;
    }

    this.setState({
      userBankAccounts: verifiedBankAccounts,
      selectedBankAccId: bankAccId,
    });
  }

  public async UNSAFE_componentWillReceiveProps(nextProps: PersonalInfoProps) {
    const { detailsSlug: nextSlug } = nextProps.url.query;
    // this creates issue in modal navigation as it sends one step back
    // const { detailsSlug } = this.state;
    // if (detailsSlug !== nextSlug) {
    //   this.pushStateAndNavigate(nextSlug, true);
    // }

    if (nextProps.bankErrorMsg && nextProps.bankErrorMsg.length > 0) {
      this.setState({ isSubmiting: false });
    }
    if (
      nextSlug !== 'third' &&
      nextSlug !== 'payment' &&
      nextSlug !== 'first' &&
      nextProps.isBankVerified
    ) {
      const response = await api.getUserDetails();
      if (response) {
        const { entity } = response.response;
        this.setState({ entity }, () => this.pushStateAndNavigate('third'));
      }
    }
    if (
      nextProps.investmentToken &&
      nextProps.investmentToken !== this.state.investmentToken
    ) {
      this.setState({ investmentToken: nextProps.investmentToken });
    }
    if (nextProps.isOtpVerified && nextSlug === 'third') {
      this.pushStateAndNavigate('payment');
    }
  }

  private async updateStateFromProps() {
    const { entity } = this.props;
    if (!entity) {
      const response = await api.getUserDetails();
      if (response) {
        const { entity: innerEntity } = response.response || {};
        this.handleIntialResponse(
          innerEntity,
          this.filterFieldsToDisplay.bind(this)
        );
      }
    } else {
      this.handleIntialResponse(entity, this.handleInvestedUserCase.bind(this));
    }
    await this.setBankAcounts();
  }

  private handleIntialResponse(entity: UserEntity, callback: VoidFunction) {
    const { query } = this.props.url;
    // const { isBankVerified } = this.props;
    const detailsSlug = query.detailsSlug || 'first';
    const { hasUserInvested = false } = entity;

    if (this.props.pennyDropPending) {
      this.props.doPennyDrop(entity, null);
    }
    this.setState(
      {
        entity,
        hasUserInvested,
        detailsSlug,
      },
      () => callback()
    );
  }

  private handleInvestedUserCase() {
    const { hasUserInvested, isOtpAlreadyVerified } = this.state;
    const { isOtpVerified } = this.props;
    if (hasUserInvested) {
      api.getUserDetails(true).then((response) => {
        const apiRes = response.response;

        if (apiRes && isObjectEmpty(apiRes.errors)) {
          if (!isOtpAlreadyVerified && !isOtpVerified) {
            this.pushStateAndNavigate('third');
          } else {
            this.pushStateAndNavigate('payment');
            this.trackClick();
          }
        } else {
          this.pushStateAndNavigate('second');
          this.showErrorFields(apiRes.errors, apiRes.entity);
        }
      });
    } else {
      this.filterFieldsToDisplay();
    }
  }

  private handleAutoFills() {
    const { formValues, entity } = this.state;
    formValues.forEach((field, index) => {
      const { name, entityKey } = field;
      if (name === 'pan') {
        const { pan = '' } = entity[entityKey] || {};
        this.handlePanKyc(pan || '');
      } else if (name === 'ifscCode') {
        const { ifscCode = '', bankCode = '' } = entity[entityKey] || {};
        if (!bankCode) {
          this.handleIfscFetch(ifscCode || '');
        }
      } else if (name === 'pincode') {
        const { pincode = '', state = '' } = entity[entityKey] || {};
        if (!state) {
          this.lookupPincode(pincode || '', index);
        }
      }
      if (
        name === 'accountType' ||
        name === 'taxPayerId' ||
        name === 'taxResidenceCountry'
      ) {
        field.value = entity[entityKey][name];
      }
    });
  }

  private async filterFieldsToDisplay(key?: string) {
    const { detailsSlug, entity, hasUserInvested } = this.state;
    // let hasUserInvested = true;
    const { isEditFromProfile } = this.props;
    key = key || detailsSlug;
    let addNRIFields = false;

    const nomineeNameAdded =
      entity.userPersonalDetails && entity.userPersonalDetails.nomineeName
        ? true
        : false;
    const nomineeRelationAdded =
      entity.userPersonalDetails && entity.userPersonalDetails.nomineeRelation
        ? true
        : false;
    const nomineeDOBAdded =
      entity.userPersonalDetails &&
      entity.userPersonalDetails.nomineeDateOfBirth
        ? true
        : false;
    const pennyDropStatus = await api.getUserPennyDropStatus();
    const isPennyDropVerified =
      pennyDropStatus && pennyDropStatus.bankAccountStatus === 'ACTIVE'
        ? true
        : false;
    if (key && DETAIL_FIELDS[key]) {
      const fieldsToDisplay = DETAIL_FIELDS[key].map((field) => {
        const { entityKey, name } = field;
        const entityDTO = entity[entityKey] || {};
        let existingValue = entityDTO[name];

        if (isEditFromProfile && detailsSlug === 'second') {
          existingValue = field.value;
        }
        let value = existingValue || field.value;
        let disabled = false;
        if (existingValue) {
          disabled =
            (hasUserInvested ||
              Boolean(
                name === 'nameOfBank' &&
                  entityDTO['ifscCode'] &&
                  entityDTO['bankCode']
              )) &&
            !isEditFromProfile;
        } else {
          disabled = false;
        }

        // If User has already Invested disable fields so that user is not allowed to edit details

        if (name === 'nomineeName') {
          disabled = nomineeNameAdded && hasUserInvested;
        }
        if (name === 'nomineeRelation') {
          disabled = nomineeRelationAdded && hasUserInvested;
        }
        if (name === 'nomineeDateOfBirth') {
          disabled = nomineeDOBAdded && hasUserInvested;
        }
        if (
          (name === 'accountNo' ||
            name === 'ifscCode' ||
            name === 'nameOfBank' ||
            name === 'cityOfBank') &&
          !isEditFromProfile
        ) {
          disabled = isPennyDropVerified;
        }
        if (name === 'fullName' || name === 'pan') {
          disabled = isPennyDropVerified;
        }

        if (
          value &&
          (name === 'dateOfBirth' || name === 'nomineeDateOfBirth')
        ) {
          const dob = value.split('-');
          value = `${dob[2]}/${dob[1]}/${dob[0]}`;
        }
        if (value && name === 'isTaxPayerOutsideIndia') {
          value = value === 'yes';
          addNRIFields = value;
          this.setState({ showNRIField: value });
        }
        return { ...field, value, disabled };
      });
      this.setState(
        {
          formValues: addNRIFields
            ? DETAIL_FIELDS[key].filter(
                (item) => item.name === 'isTaxPayerOutsideIndia'
              )
            : fieldsToDisplay,
          isSubmiting: false,
        },
        () => {
          this.handleAutoFills();
        }
      );
    }
  }

  public onChange = (e: any) => {
    const { value, name } = e.target;
    let { formValues, bankCode } = this.state;
    if (name === 'nameOfBank') {
      bankCode = value;
    }
    // else if (name === 'pan') {
    //   this.handlePanKyc(value);
    // }
    formValues = formValues.map((field, index) => {
      if (field.name === name) {
        field.value =
          name === 'pan' || name === 'ifscCode' ? value.toUpperCase() : value;

        if (field.name === 'pincode') {
          this.lookupPincode(value, index);
        }
        if (field.name === 'ifscCode') {
          this.handleIfscFetch(value);
        }
      }
      return field;
    });
    this.setState({ formValues, bankCode, value });
  };

  private trackClick() {
    const { detailsSlug } = this.state;
    const { selectedFund, trackLabel } = this.props;
    const trackActionData = investFlowTrackActionData[detailsSlug];
    const fundName = selectedFund && selectedFund.fundName;
    const modalLabel = trackLabel || 'invest_flow';
    handleTrack({
      label: `${modalLabel}_${fundName}_${detailsSlug}_${trackActionData.action}`,
    });
  }

  public submitForm = () => {
    const { isEditFromProfile, userBankAccounts } = this.props;
    const { formValues, showNRIField, detailsSlug } = this.state;
    const isUnbanked = userBankAccounts && userBankAccounts.length < 1;
    if (showNRIField) {
      this.setState({ isSubmiting: false });
      return;
    }

    this.setState({ isSubmiting: true }, async () => {
      const { isValid, validatedArr } = validate(formValues);
      if (!isValid) {
        this.setState({ formValues: validatedArr, isSubmiting: false });
      } else {
        const requestObj = this.getRequestData(validatedArr);
        if (!isEditFromProfile) {
          this.trackClick();
        }
        if (isEditFromProfile && detailsSlug === 'second' && !isUnbanked) {
          this.addBankAccount(requestObj);
        } else {
          this.submitUserData(requestObj);
        }
      }
    });
  };

  private addBankAccount(requestObj: any) {
    const { doPennyDrop, personalDetailsUpdated } = this.props;
    const { accountNo, ifscCode, cityOfBank, nameOfBank, branchName, primary } =
      requestObj.userBankDetails;
    const bankDetails = {
      accountNo,
      ifscCode,
      cityOfBank,
      nameOfBank,
      branchName,
      primary,
    };
    doPennyDrop(requestObj, (succeed: boolean) => {
      if (succeed) {
        api.addBankAccount(bankDetails).then((res) => {
          if (res && res.success && isObjectEmpty(res.errorDTO)) {
            this.setBankAcounts();
            personalDetailsUpdated();
          } else {
            if (res.errorDTO && res.errorDTO.message) {
              this.setState({
                bankErrMsg: res.errorDTO.messgae,
              });
            }
          }
        });
      }
    });
  }

  private async submitUserData(requestObj: any) {
    const { detailsSlug, skipUserDetails } = this.state;
    const { isEditFromProfile, personalDetailsUpdated, doPennyDrop } =
      this.props;
    const pennyDropStatus = await api.getUserPennyDropStatus();
    const isPennyDropVerified =
      pennyDropStatus && pennyDropStatus.bankAccountStatus === 'ACTIVE'
        ? true
        : false;
    const query = detailsSlug === 'second' ? 'PRE_PAYMENT_CHECKS' : '';

    // Add nominee percentage share if submitting nominee details
    if (
      detailsSlug === 'third' &&
      requestObj.userPersonalDetails &&
      requestObj.userPersonalDetails.nomineeName
    ) {
      // Check if nomineePercentageShare is null or empty and assign "100"
      if (!requestObj.userPersonalDetails.nomineePercentageShare) {
        requestObj.userPersonalDetails.nomineePercentageShare = '100';
      }
    }

    if (detailsSlug === 'second' && !isPennyDropVerified) {
      doPennyDrop(requestObj, (succeed: boolean) => {
        if (succeed) {
          api.updateUserDetails(requestObj, query).then((response) => {
            const apiRes = response.response;
            if (apiRes) {
              if (isEditFromProfile) {
                personalDetailsUpdated();
              } else {
                this.setState({ entity: apiRes.entity }, () => {
                  this.pushStateAndNavigate('third');
                });
              }
            }
          });
        }
      });
    } else {
      api.updateUserDetails(requestObj, query).then((response) => {
        const apiRes = response.response;
        if (apiRes && isObjectEmpty(apiRes.errors)) {
          this.setState({ entity: apiRes.entity }, () => {
            const slug = skipUserDetails ? 'payment' : detailsSlug;
            if (slug && !isEditFromProfile) {
              this.handleModalNavigation(slug);
            } else {
              personalDetailsUpdated();
            }
          });
        } else {
          this.setState({ entity: apiRes.entity }, () => {
            this.showErrorFields(apiRes.errors, apiRes.entity);
          });
        }
      });
    }
  }

  private getRequestData(validatedArr: any[]) {
    const { entity, ifscResponse, bankCode, pincodeResponse, showNRIField } =
      this.state;
    const { BRANCH } = ifscResponse;
    const requestObj = {
      userBankDetails: {},
      userPersonalDetails: {},
      userFatcaDetails: {},
    };
    validatedArr.forEach((field) => {
      const { value, entityKey, name } = field;
      if (entityKey) {
        let val = typeof value === 'string' ? value.trim() : value;
        if (name === 'nameOfBank') {
          const bank = BANK_CODES.filter(
            (bankObj: any) => bankCode === bankObj.value
          )[0];
          requestObj[entityKey]['bankCode'] = bankCode;
          requestObj[entityKey]['branchName'] = (BRANCH || '').slice(0, 40);
          val = bank ? bank.label : bankCode === '' ? value : '';
        } else if (name === 'pincode') {
          const { stateCode } = pincodeResponse;
          requestObj[entityKey]['state'] = stateCode;
        } else if (name === 'dateOfBirth' || name === 'nomineeDateOfBirth') {
          const dob = value.split('/');
          val = `${dob[2]}-${dob[1]}-${dob[0]}`;
        } else if (name === 'isTaxPayerOutsideIndia') {
          val = val ? 'yes' : 'no';
        } else if (showNRIField) {
          if (value === 'NRE') {
            requestObj['userFatcaDetails']['sourceOfWealth'] = '21';
          } else if (value === 'NRO') {
            requestObj['userFatcaDetails']['sourceOfWealth'] = '11';
          }
        } else {
          requestObj['userFatcaDetails']['sourceOfWealth'] = '01';
        }
        requestObj[entityKey][name] = val;
      }
    });
    return this.mergeObjects(entity, requestObj);
  }

  private mergeObjects(target: object, source: object) {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        const s = source[key];
        if (typeof s === 'object') {
          target[key] = target[key] || {};
          this.mergeObjects(target[key], s);
        } else if (s) {
          if (key === 'accountNo' && s !== target[key]) {
            trackPixel('AddPaymentInfo');
            trackAction('bank-info', 'added-payment-info', 'payment-info');
          }
          target[key] = s;
        }
      }
    }
    return target;
  }

  private showErrorFields(errors: object, entity: Record<string, any>) {
    const DTO_MAP = {
      userBankDetails: 'UserBankDetailsDTO',
      userPersonalDetails: 'UserPersonalDetailsDTO',
    };
    const newFormValues = [];
    let nomineeNameItem;
    let nomineeRelationItem;
    let nomineeDOBItem;
    let nomineeNameError = false;
    let nomineeRelationError = false;
    let nomineeDOBError = false;
    ALL_FIELDS.forEach((item) => {
      const { entityKey, name } = item;
      const entityDTO = DTO_MAP[entityKey];
      const isBankCodeEmpty =
        name === 'nameOfBank' &&
        errors[entityDTO] &&
        errors[entityDTO]['bankCode'];
      const nomineeNameAdded =
        entity.userPersonalDetails && entity.userPersonalDetails.nomineeName
          ? true
          : false;
      const nomineeRelationAdded =
        entity.userPersonalDetails && entity.userPersonalDetails.nomineeRelation
          ? true
          : false;
      const nomineeDOBAdded =
        entity.userPersonalDetails &&
        entity.userPersonalDetails.nomineeDateOfBirth
          ? true
          : false;
      const isNomineeNameEmpty = name === 'nomineeName' && !nomineeNameAdded;
      const isNomineeRelationEmpty =
        name === 'nomineeRelation' && !nomineeRelationAdded;
      const isNomineeDOBEmpty =
        name === 'nomineeDateOfBirth' && !nomineeDOBAdded;
      const newItem = { ...item };
      newItem.value = entity[entityKey][name] || '';
      if (item.name === 'nomineeName') {
        nomineeNameItem = { ...newItem };
      }
      if (item.name === 'nomineeRelation') {
        nomineeRelationItem = { ...newItem };
      }
      if (item.name === 'nomineeDateOfBirth') {
        nomineeDOBItem = { ...newItem };
      }
      if (
        (errors[entityDTO] && errors[entityDTO][name]) ||
        isBankCodeEmpty ||
        isNomineeNameEmpty ||
        isNomineeRelationEmpty ||
        isNomineeDOBEmpty
      ) {
        if (item.name === 'nomineeName') {
          nomineeNameError = true;
        }
        if (item.name === 'nomineeRelation') {
          nomineeRelationError = true;
        }
        if (item.name === 'nomineeDateOfBirth') {
          nomineeDOBError = true;
        }
        newItem.isInvalid = true;
        newItem.validationMessage =
          (errors[entityDTO][name] && errors[entityDTO][name][0]) ||
          'Enter a valid value';
        if (newItem.name === 'nomineeDateOfBirth') {
          if (newItem.value) {
            const dob = newItem.value.split('-');
            newItem.value = `${dob[2]}/${dob[1]}/${dob[0]}`;
          } else {
            newItem.validationMessage =
              'Date should be DD/MM/YYYY format and age should be less than 100 yrs old';
          }
        }
        if (newItem.name === 'dateOfBirth') {
          if (newItem.value) {
            const dob = newItem.value.split('-');
            newItem.value = `${dob[2]}/${dob[1]}/${dob[0]}`;
          } else {
            newItem.validationMessage =
              'Date should be DD/MM/YYYY format and age should be less than 100 yrs old';
          }
        }
        newFormValues.push(newItem);
      }
    });
    // Add all other nominee items if any one fails
    const nomineeError =
      nomineeNameError || nomineeRelationError || nomineeDOBError;
    if (nomineeError) {
      if (!nomineeNameError) {
        nomineeNameItem.disabled = true;
        newFormValues.push(nomineeNameItem);
      }
      if (!nomineeRelationError) {
        nomineeRelationItem.disabled = true;
        newFormValues.push(nomineeRelationItem);
      }
      if (!nomineeDOBError) {
        nomineeDOBItem.disabled = true;
        newFormValues.push(nomineeDOBItem);
      }
    }
    this.setState({ formValues: newFormValues, isSubmiting: false });
  }

  private triggerCreateActivity(
    activityCode: number,
    page: string,
    phone: string
  ) {
    createActivity({
      ActivityEvent: activityCode,
      ActivityNote: `On ${page} details page`,
      Phone: phone,
    });
  }

  private handleModalNavigation(slug: string) {
    const { phone } = this.props.entity.userPersonalDetails;
    const { showOtpScreen } = this.props;
    if (slug === 'first') {
      this.triggerCreateActivity(184, 'personal', phone);
      this.pushStateAndNavigate('second');
    } else if (slug === 'second') {
      this.triggerCreateActivity(186, 'bank', phone);
      this.pushStateAndNavigate('third');
    } else if (slug === 'third') {
      if (!this.state.isOtpAlreadyVerified) {
        showOtpScreen(); // Otp verification screen before payment
      } else {
        this.triggerCreateActivity(186, 'nominee', phone);
        this.pushStateAndNavigate('payment');
      }
    } else {
      this.triggerCreateActivity(185, 'additional', phone);
      this.pushStateAndNavigate('payment');
    }
  }

  public handleSkipNominee = () => {
    this.setState({ isSubmiting: true }, async () => {
      // Create request object with nomineeOpted: false
      const requestObj = {
        userPersonalDetails: {
          nomineeOpted: false,
        },
      };

      const mergedRequestObj = this.mergeObjects(this.state.entity, requestObj);

      if (mergedRequestObj.userPersonalDetails) {
        mergedRequestObj.userPersonalDetails.nomineeOpted = false;
      }

      // Make API call directly, bypassing validation
      api.updateUserDetails(mergedRequestObj, '0').then((response) => {
        const apiRes = response.response;
        if (apiRes && isObjectEmpty(apiRes.errors)) {
          this.setState({ entity: apiRes.entity }, () => {
            // Navigate to payment step
            this.handleModalNavigation('payment');
          });
        } else {
          this.setState({
            entity: apiRes.entity,
            isSubmiting: false,
          });
        }
      });
    });
  };

  public pushStateAndNavigate(slug: string, pushPath: boolean = true) {
    if (pushPath) {
      const { pathname, search } = window.location;
      const newSearch = search.replace(
        /(=?(first)|=?(second)|=?(third)|=?(payment))/g,
        `=${slug}`
      );
      const url = `${pathname}${newSearch}`;
      Router.pushRoute(url, url, { shallow: true });
    }
    const showNRIField = slug === 'second' ? this.state.showNRIField : false;
    this.setState({ detailsSlug: slug, showNRIField });
    this.filterFieldsToDisplay(slug);
  }

  // Remove this commented code to unblock NRIs
  // Function to arrange the form fields
  // public shuffleFormValuesIfNRI = (NRIFields: any[], formValues: any[]) => {
  //   return [
  //     ...formValues.slice(0, 3),
  //     NRIFields[0],
  //     ...formValues.slice(3, formValues.length - 1),
  //     ...NRIFields.slice(1),
  //     ...formValues.slice(formValues.length - 1),
  //   ];
  // };

  // Toggle NRI button function
  public toggleNRI = () => {
    const { showNRIField } = this.state;
    let { formValues } = this.state;
    const { detailsSlug } = this.state;

    if (showNRIField) {
      this.filterFieldsToDisplay(detailsSlug);
    } else if (!showNRIField) {
      formValues = formValues.filter(
        (item) => item.name === 'isTaxPayerOutsideIndia'
      );
      this.setState({ formValues });
    }
    this.setState({ showNRIField: !showNRIField });

    // Remove this commented code to unblock NRIs
    // if (showNRIField) {
    //   formValues = formValues.filter(
    //     field =>
    //       field.name !== 'accountType' &&
    //       field.name !== 'taxResidenceCountry' &&
    //       field.name !== 'taxPayerId'
    //   );
    // } else if (!showNRIField) {
    //   const NRIFields = NRI_FIELDS.map(field => {
    //     return {
    //       ...field,
    //       value: entity.userPersonalDetails[field.name] || '',
    //     };
    //   });
    //   formValues = this.shuffleFormValuesIfNRI(NRIFields, formValues);
    // }
    // this.setState({ showNRIField: !showNRIField, formValues });
  };

  public processsPaymentViaRazorpay = (response: any) => {
    const {
      razorpayCheckoutDTO: {
        callbackUrl,
        checkoutParams: {
          amount,
          key,
          order_id,
          name,
          'prefill.contact': prefillContact,
          'prefill.email': prefillEmail,
          'prefill.name': prefillName,
        },
      },
    } = response;
    const rpOptions = {
      ...RAZORPAY_OPTIONS,
      callback_url: `${callbackUrl}?order_id=${order_id}`,
      amount: parseInt(amount, 10),
      key,
      order_id,
      name,
      prefill: {
        email: prefillEmail,
        contact: prefillContact,
        name: prefillName,
      },
    };

    const rpInstance = new Razorpay(rpOptions);
    rpInstance.open();
  };

  public placeOrder = () => {
    const { formValues, selectedBankTpvData, investmentToken } = this.state;
    const {
      url: {
        query: { useRazorpay },
      },
      investmentOwnerCode,
      toggleInvestmentOwnerCodeHasError,
    } = this.props;

    const value = formValues && formValues[0] && formValues[0].value;

    if (!value && useRazorpay === '1') {
      formValues[0].isInvalid = true;
      formValues[0].validationMessage = 'Please select payment option';
      this.setState({ formValues });
      return null;
    }
    this.setState({ isSubmiting: true });
    trackPixel('InitiateCheckout');
    this.trackClick();

    const requestBody = {
      ownerCode: investmentOwnerCode,
    };
    if (useRazorpay !== '1') {
      if (!investmentOwnerCode) {
        toggleInvestmentOwnerCodeHasError(true);
        this.setState({ isSubmiting: false });
        return;
      } else {
        toggleInvestmentOwnerCodeHasError(false);
      }

      let paymentMethod = 'UNKNOWN';
      if (
        selectedBankTpvData &&
        selectedBankTpvData.NetBankingPresent === 1 &&
        selectedBankTpvData.UPIPresent === 0
      ) {
        paymentMethod = 'NET_BANKING';
      } else if (
        selectedBankTpvData &&
        selectedBankTpvData.NetBankingPresent === 0 &&
        selectedBankTpvData.UPIPresent === 1
      ) {
        paymentMethod = 'UPI';
      }

      api
        .placeOrderV2(
          PAYMENT_GATEWAYS.razorpay,
          paymentMethod,
          requestBody,
          this.state.selectedBankAccId,
          investmentToken
        )
        .then((res) => {
          this.setState({ isSubmiting: false });
          if (res && res.httpStatus !== 200) {
            showError(res.message || ERROR_MESSAGES.generic);
            return;
          }
          this.processsPaymentViaRazorpay(res.response);
        })
        .catch((err) => {
          this.setState({ isSubmiting: false });
          throw err;
        });
    } else {
      api
        .placeOrder(value, investmentToken)
        .then((res) => {
          if (res && res.httpStatus !== 200) {
            showError(res.message || ERROR_MESSAGES.generic);
            return;
          }
          this.setState({ billdeskResponse: res.response }, () => {
            if (this.billdeskForm) {
              this.billdeskForm.submit();
            }
          });
        })
        .catch((err) => {
          this.setState({ isSubmiting: false });
          throw err;
        });
    }
  };

  public onBlur = (index: number, e: any) => {
    const { name, value } = e.target;
    if (value && name === 'ifscCode') {
      this.handleIfscFetch(value);
    } else if (name === 'pan') {
      this.handlePanKyc(value);
    } else if (name === 'pincode') {
      this.lookupPincode(value, index);
    }
  };

  public async lookupPincode(pincode: string, index?: any) {
    const code = pincode.trim();
    if (code.length === 6) {
      const pincodeResponse = await api.lookupPincode(code);
      const { response } = pincodeResponse;
      const { formValues } = this.state;
      formValues[index].isInvalid = false;

      this.setState(
        { formValues, pincodeResponse: response || {} },
        this.prefillCity
      );
    }
  }

  private getSubOfficeName(value: string) {
    const soIndex = value.indexOf(' S.O');
    const valueIndex = soIndex !== -1 ? soIndex : value.indexOf(' SO');
    return valueIndex === -1 ? value : value.substr(0, valueIndex);
  }

  private prefillCity = async () => {
    const {
      formValues,
      pincodeResponse: { subOffice, district },
    } = this.state;

    const city = subOffice ? this.getSubOfficeName(subOffice) : district;
    formValues.forEach((field) => {
      const { name } = field;
      if (name === 'city') {
        field.value = city;
        field.isInvalid = false;
      }
    });

    this.setState({ formValues });
  };

  public async handlePanKyc(value: string) {
    const val = value.trim();
    if (val.length === 10) {
      const kycResponse = await api.handleKycCheck(
        { pan: val },
        'details-component'
      );
      this.setState({
        kycStatusResponse: kycResponse || ({} as KYCStatusResponse),
      });
    }
  }

  public async handleIfscFetch(value: string) {
    const val = value.trim();
    const { formValues } = this.state;
    let bankCode = '';
    let city = '';
    let bank = '';
    let ifscResponse = {} as any;
    if (val.length === 11) {
      ifscResponse = await api.getIfscInfo(val);
      if (ifscResponse && typeof ifscResponse !== 'string') {
        const { BANKCODE, CITY, BANK } = ifscResponse;

        // check banks we support
        const supportedBank = BANK_CODES.find(
          (bankObj) => bankObj.razorPayCode === BANKCODE
        );

        if (supportedBank) {
          bankCode = supportedBank.value;
        }

        bank = BANK;
        city = CITY;
      }
    }
    formValues.forEach((field) => {
      const { name } = field;
      if (name === 'nameOfBank') {
        field.value = bank;
        field.isInvalid = false;
        field.disabled = Boolean(bank);
      } else if (name === 'cityOfBank') {
        field.value = city;
        field.isInvalid = false;
      }
    });
    this.setState({
      formValues,
      ifscResponse,
      bankCode,
    });
  }

  private confirmUpiPaymentNote = (e: any) => {
    this.setState({
      upiCheckbox: e.target.checked,
    });
  };

  private handlePaymentSchedule = () => {
    const {
      url: {
        query: { useRazorpay },
      },
      investmentOwnerCode,
      toggleInvestmentOwnerCodeHasError,
    } = this.props;
    const { query } = this.props.url;
    const { detailsSlug, id, ...queryObj } = query;
    queryObj.schedulePayment = 'methodSelect';
    queryObj.investmentOwnerCode = investmentOwnerCode;

    if (useRazorpay !== '1') {
      if (!investmentOwnerCode) {
        toggleInvestmentOwnerCodeHasError(true);
        this.setState({ isSubmiting: false });
        return;
      } else {
        toggleInvestmentOwnerCodeHasError(false);
      }
    }
    trackAction(
      'click',
      'schedule-payment-flow',
      'proceed-to-schedule-payment'
    );
    Router.pushRoute(`${location.pathname}?${stringify(queryObj)}`);
  };

  private getButtonProps = (isPaymentScreen: boolean) => {
    const { isSubmiting, upiCheckbox, value, btnText } = this.state;
    let loadingLabel = isPaymentScreen ? 'Investing...' : 'Submiting...';
    let disabled = isSubmiting;
    if (isPaymentScreen && value === 'UPI') {
      disabled = isSubmiting || !upiCheckbox;
    }
    if (isPaymentScreen && !upiCheckbox) {
      loadingLabel = 'Invest Now';
    }
    return {
      disabled,
      loadingLabel,
      onClick: isPaymentScreen
        ? btnText === 'PROCEED TO SCHEDULE PAYMENT'
          ? this.handlePaymentSchedule
          : this.placeOrder
        : this.submitForm,
    };
  };

  private handleScheduleBtn = async () => {
    const { cart } = this.props;
    const { selectedBankAccId } = this.state;
    if (cart) {
      const res = await api.getMandateStatus(
        cart.totalAmount,
        selectedBankAccId
      );
      if (res && res.status !== 404) {
        this.setState({
          enableScheduleLater: true,
        });
      } else {
        this.setState({
          enableScheduleLater: false,
        });
      }
    }
  };
  // Remove comment to enable payment schedule
  // private handleBtnText = (e: any) => {
  //   const { value } = e.target;
  //   trackAction(
  //     'radio-click',
  //     'schedule-payment-flow',
  //     value === 'now' ? 'pay-now' : 'schedule-a-date'
  //   );
  //   this.setState({
  //     btnText:
  //       value === 'now' ? 'PROCEED TO PAY' : 'PROCEED TO SCHEDULE PAYMENT',
  //   });
  // };

  private handleValidateAccount = () => {
    Router.push('/save/profile?modal=validate');
  };

  private handleAddAccount = () => {
    Router.push('/save/profile?modal=addBank');
  };

  public render() {
    const {
      detailsSlug,
      showNRIField,
      formValues,
      hasUserInvested,
      kycStatusResponse,
      value,
      isSubmiting,
      entity = {},
      upiCheckbox,
      bankErrMsg,
      userBankAccounts,
      selectedBankAccId,
      // enableScheduleLater,
    } = this.state;
    const {
      url: {
        query: { useRazorpay },
      },
      handleEditAmount,
      onEditFunds,
      hideEditFunds,
      investmentOwnerCodeHasError,
      SipDateHasError,
      cart,
      kycCheck,
      handleBack,
      isEditFromProfile,
      bankErrorMsg,
      isPaymentMode,
    } = this.props;
    const bankCode = (entity.userBankDetails || {}).bankCode || '';
    const isNoBankVerified = userBankAccounts && userBankAccounts.length < 1;

    // Show KYC Error ONLY IF allowedToInvest is false (not undefined, not null)
    const { allowedToInvest } = kycStatusResponse;
    if (typeof allowedToInvest === 'boolean' && !allowedToInvest) {
      return <KycError />;
    }

    const filteredBankList = BANK_CODES.filter(
      (bankObj) => bankObj.value === bankCode
    );
    const paymentModes =
      useRazorpay !== '1'
        ? RAZORPAY_PAYMENT_OPTIONS
        : (filteredBankList[0] || {}).paymentModes || DEFAULT_PAYMENT_MODES;

    const isPaymentScreen = detailsSlug === 'payment';

    if (
      (!isEditFromProfile && (!cart || !cart.items.length)) ||
      (isEditFromProfile && !entity.userPersonalDetails)
    ) {
      return <Loader size="40px" />;
    }

    let kycStatus;
    let showKycError;
    if (kycCheck) {
      const { kycStatus: ndmlKycStatus, allowedToInvest: ndmlAllowedToInvest } =
        kycCheck;
      showKycError =
        typeof ndmlAllowedToInvest === 'boolean' && !ndmlAllowedToInvest;
      kycStatus = ndmlKycStatus;
    }

    const investmentTypeText =
      cart && cart.items[0].itemType === 'SIP_MF' ? 'SIP' : 'One Time';
    let primaryBtnText;
    if (isPaymentScreen) {
      primaryBtnText = 'Invest Now';
    } else if (isEditFromProfile && detailsSlug === 'second') {
      primaryBtnText = 'Add bank';
    } else if (isEditFromProfile) {
      primaryBtnText = 'Submit';
    } else {
      primaryBtnText = 'Next';
    }

    const getPaymentFundView = () => {
      return (
        <div className={cx(styles['fund-payment-details'])}>
          <FundList onEdit={onEditFunds} cart={cart} hideEdit={hideEditFunds} />
          <div className={'row mt15'}>
            <div
              className={'columns small-12 mb10 font--black text--uppercase'}
            >
              Payment Details
            </div>
            <div className={'columns small-4 large-5'}>
              <span className={'text--normal font--grey font--medium'}>
                Investment Amount
              </span>
            </div>
            <div className="columns small-8 large-7 lil-flex lil-items-center lil-flex-wrap">
              <span className="text--xlg font--bold">
                ₹ {cart.totalAmount.toLocaleString('en-IN')} (
                {investmentTypeText})
              </span>
              {handleEditAmount ? (
                <span
                  className={cx(
                    'text--sm text--uppercase cursor--pointer verticle-align-middle ml10',
                    styles['edit-btn']
                  )}
                  onClick={handleEditAmount}
                >
                  Change
                </span>
              ) : null}
            </div>
          </div>
        </div>
      );
    };

    const {
      selectedFund,
      handleInvestmentOwner,
      toggleInvestmentOwnerCodeHasError,
      investmentOwnerCode,
      personalDetails,
      investmentType,
      toggleSIPDateSelectorHasError,
      sipDates,
      scheduleLater,
      // scheduleModal,
      dissmissScheduleModal,
      dismissModal,
    } = this.props;
    const { sipEnabled = true, lumpSumEnabled = true } = selectedFund || {};
    const disabled = !sipEnabled && !lumpSumEnabled;

    return (
      <Fragment>
        <div
          className={cx(this.props.className || 'large-8', 'columns', {
            [styles.columns]: !scheduleLater,
          })}
        >
          <div className={cx(commonStyles.paper)}>
            {useRazorpay !== '1' &&
              detailsSlug === 'payment' &&
              !scheduleLater &&
              getPaymentFundView()}
            <div
              className={cx(
                styles['fields'],
                styles['fields-max-height'],
                'columns large-12',
                styles.pl0,
                styles['srollable-view'],
                styles.columns,
                {
                  [styles['no-min-height']]: useRazorpay !== '1',
                }
              )}
            >
              {!(useRazorpay !== '1' && detailsSlug === 'payment') &&
                formValues.map((field, index) => {
                  let onChange = this.onChange;
                  if (field.type === 'toggle-switch') {
                    field.value = showNRIField;
                    onChange = this.toggleNRI;
                  }
                  return (
                    <Fragment>
                      <Field
                        id={field.name}
                        key={field.name}
                        disabled={isSubmiting}
                        {...field}
                        onChange={onChange}
                        paymentModes={paymentModes}
                        onBlur={this.onBlur.bind(this, index)}
                      />
                      {showNRIField &&
                      field.name === 'isTaxPayerOutsideIndia' ? (
                        <p className="font--red columns large-12 pb30">
                          We are currently serving investments only to Indian
                          citizens residing in India.
                        </p>
                      ) : null}
                    </Fragment>
                  );
                })}
              {detailsSlug === 'third' && (
                <div className="columns large-12 mt20 mb20 text-center">
                  <button
                    className="lil-btn lil-btn-white lil-border-sm m-nostyle"
                    onClick={this.handleSkipNominee}
                    disabled={isSubmiting}
                  >
                    Continue without nominee
                  </button>
                </div>
              )}
              {/*invalidBank ? (
                <div className="large-12 columns">
                  <p className="bank-warning">{invalidBank}</p>
                </div>
              ) : null*/}
              {isPaymentScreen ? (
                <Fragment>
                  {value === 'UPI' ? (
                    <p>
                      <input
                        type="checkbox"
                        className="mr10 text--xlg cursor--pointer"
                        onChange={this.confirmUpiPaymentNote}
                        checked={upiCheckbox}
                      />
                      I accept that I'm making the payment using the VPA linked
                      to the same account as entered here in bank details
                    </p>
                  ) : null}
                  {!(useRazorpay !== '1' && isPaymentScreen) ? (
                    <p className="terms font--fadedgrey">
                      By clicking Invest Now, you confirm that you've read{' '}
                      <a
                        href="https://cleartax.in/s/mutual-fund-investment-documents"
                        target="_blank"
                      >
                        {' '}
                        Mutual Fund Investment documents{' '}
                      </a>{' '}
                      and ClearTax{' '}
                      <a href="https://cleartax.in/meta/terms" target="_blank">
                        {' '}
                        Terms &amp; Conditions{' '}
                      </a>{' '}
                      and agree to the same
                    </p>
                  ) : null}
                </Fragment>
              ) : null}
              <style jsx>{`
                :global(*.disable) {
                  opacity: 0.6;
                  cursor: initial;
                }
                :global(.paper) .terms {
                  font-size: 12px;
                }
                :global(.paper) .terms a {
                  display: inline;
                  border-bottom: none;
                }
                .bank-warning {
                  color: red;
                  padding: 15px 0;
                  font-size: 12px;
                  font-weight: bold;
                }
              `}</style>
            </div>

            <div
              className={cx(
                styles['action-container'],
                'columns large-12 pt10',
                styles.columns,
                {
                  [styles['fix-box-width']]:
                    useRazorpay !== '1' && isPaymentScreen,
                  'lil-flex lil-items-center':
                    isEditFromProfile && detailsSlug === 'second',
                }
              )}
            >
              {bankErrorMsg && bankErrorMsg.length > 0 ? (
                <p className="font--red text--md">{bankErrorMsg}</p>
              ) : null}
              {bankErrMsg && bankErrMsg.length > 0 ? (
                <p className="font--red text--md">{bankErrMsg}</p>
              ) : null}
              {!(useRazorpay !== '1' && isPaymentScreen) ? (
                <Fragment>
                  {detailsSlug !== 'first' &&
                  !hasUserInvested &&
                  !isEditFromProfile ? (
                    <Button
                      label="Back"
                      disabled={isSubmiting}
                      loadingLabel="Back"
                      type="secondary"
                      onClick={() => {
                        const slug = handleBack();
                        this.pushStateAndNavigate(slug);
                      }}
                    />
                  ) : null}
                  {isEditFromProfile && detailsSlug === 'second' && (
                    <Fragment>
                      <img
                        src="https://assets1.cleartax-cdn.com/clearsave/images/1640202166_warning.png"
                        width="24"
                      />
                      <p className="mt5 ml10 lil-text-s-14">
                        Change in above details after first investment will
                        require paperwork. Please ensure that you give correct
                        information.
                      </p>
                    </Fragment>
                  )}
                  <Button
                    label={primaryBtnText}
                    type="primary"
                    float="fr"
                    {...this.getButtonProps(isPaymentScreen)}
                    className={
                      showNRIField || (isEditFromProfile && bankErrMsg)
                        ? 'disabled'
                        : isEditFromProfile && detailsSlug === 'second'
                        ? 'lil-w-56'
                        : ''
                    }
                  />
                </Fragment>
              ) : null}
            </div>
          </div>
          {this.state.billdeskResponse ? (
            <form
              method="post"
              action={this.state.billdeskResponse.paymentUrl}
              ref={(e) => (this.billdeskForm = e)}
            >
              {Object.keys(this.state.billdeskResponse.paymentParams).map(
                (key) => {
                  return (
                    <input
                      key={key}
                      type="hidden"
                      name={key}
                      value={this.state.billdeskResponse.paymentParams[key]}
                    />
                  );
                }
              )}
            </form>
          ) : null}
        </div>
        {scheduleLater ? (
          <ScheduleLater
            cart={cart}
            selectedBankAccId={selectedBankAccId}
            userBankAccounts={userBankAccounts}
            updateBankId={(val: number, cb: Function) => {
              this.setState(
                {
                  selectedBankAccId: val,
                },
                () => {
                  cb();
                }
              );
            }}
            sipDates={sipDates}
            investmentType={investmentType}
            dissmissScheduleModal={dissmissScheduleModal}
            dismissModal={dismissModal}
          />
        ) : (
          <Fragment>
            {isPaymentMode && useRazorpay !== '1' ? (
              <PaymentFundsSummaryNew
                bankAccounts={this.state.userBankAccounts}
                handleInvestmentOwner={handleInvestmentOwner}
                toggleInvestmentOwnerCodeHasError={
                  toggleInvestmentOwnerCodeHasError
                }
                investmentOwnerCode={investmentOwnerCode}
                investmentOwnerCodeHasError={investmentOwnerCodeHasError}
                personalDetails={personalDetails}
                kycCheck={kycCheck}
                investmentType={investmentType}
                SipDateHasError={SipDateHasError}
                toggleSIPDateSelectorHasError={toggleSIPDateSelectorHasError}
                sipDates={sipDates}
                trackLabel={this.props.trackLabel}
                updateBankId={(val: number, cb: Function) => {
                  this.setState(
                    {
                      selectedBankAccId: val,
                    },
                    () => {
                      cb();
                    }
                  );
                }}
                updateBankTpvData={(data: Record<string, any>) => {
                  this.setState({
                    selectedBankTpvData: data,
                  });
                }}
                selectedBankId={this.state.selectedBankAccId}
                handleScheduleBtn={this.handleScheduleBtn}
                isNoBankVerified={isNoBankVerified}
              />
            ) : null}
            {useRazorpay !== '1' && detailsSlug === 'payment' ? (
              <Fragment>
                {kycStatus === KYCStatus.NOT_AVAILABLE ? (
                  <div className={cx('columns large-12 mb10 mt10')}>
                    <div
                      className={'text--normal font--bold mb10 font--fadedgrey'}
                    >
                      Next Steps
                    </div>
                    <div className={cx('row')}>
                      <div className={cx('columns large-6 mb10')}>
                        <div
                          className={cx(
                            PFSStyles['kyc-heading'],
                            'text--normal'
                          )}
                        >
                          1. Complete your KYC
                        </div>
                        <img
                          className={cx(PFSStyles['kyc-img'])}
                          src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1562066103_complete-kyc.svg`}
                        />
                        <div className={PFSStyles['kyc-content']}>
                          Complete your mandatory KYC on ClearTax within 48 hrs
                          of investment
                        </div>
                      </div>
                      <div className={cx('columns large-6 mb10')}>
                        <div
                          className={cx(
                            PFSStyles['kyc-heading'],
                            'text--normal'
                          )}
                        >
                          1. Setup a Mandate
                        </div>
                        <img
                          className={cx(PFSStyles['kyc-img'])}
                          src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1562066079_complete-payment.svg`}
                        />
                        <div className={PFSStyles['kyc-content']}>
                          Setup an instruction for your bank to automate your
                          monthly SIP payments.
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div
                  className={cx(
                    styles['tnc-proceed-section'],
                    'columns large-12 bg-white paper p-sticky b0 pt10'
                  )}
                >
                  {investmentOwnerCodeHasError && (
                    <p className="text--sm font--red max-width-500 margin-auto">
                      Please select investment owner
                    </p>
                  )}
                  {SipDateHasError && (
                    <p className="text--sm font--red max-width-500 margin-auto">
                      Please select SIP Date
                    </p>
                  )}

                  {this.state.selectedBankTpvData && (
                    <div className={cx('lil-flex', styles['btn-wrapper'])}>
                      {isNoBankVerified ? (
                        <Fragment>
                          <div>
                            <button
                              className="lil-btn lil-btn-white lil-border-sm lil-mr-4 m-nostyle"
                              onClick={this.handleAddAccount}
                            >
                              Add New Bank
                            </button>
                          </div>
                          <div>
                            <button
                              className="lil-btn lil-mr-4 lil-btn-blue m-nostyle lil-border-sm"
                              onClick={this.handleValidateAccount}
                            >
                              Validate my account
                            </button>
                          </div>
                        </Fragment>
                      ) : (
                        <Fragment>
                          {/* {enableScheduleLater && (
                            <div>
                              <button
                                className="lil-btn lil-mr-4 lil-btn-white lil-border-sm m-nostyle"
                                onClick={scheduleModal}
                                disabled={isNoBankVerified || showKycError}
                              >
                                Schedule Order
                              </button>
                            </div>
                          )} */}
                          <div>
                            <button
                              className="lil-btn lil-btn-blue lil-mr-4 m-nostyle lil-border-sm"
                              onClick={this.placeOrder}
                              disabled={
                                disabled ||
                                isSubmiting ||
                                !this.state.selectedBankTpvData ||
                                isNoBankVerified ||
                                showKycError
                              }
                            >
                              {isSubmiting ? 'Submitting' : 'Pay Now'}
                            </button>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  )}
                  <p className="text--sm mb0 mt10 font--fadedgrey">
                    By clicking Invest Now, you confirm that you've read{' '}
                    <a
                      href="https://cleartax.in/s/mutual-fund-investment-documents"
                      target="_blank"
                      className={cx(styles['tc-link'])}
                    >
                      {' '}
                      Mutual Fund Investment documents{' '}
                    </a>{' '}
                    and ClearTax{' '}
                    <a
                      href="https://cleartax.in/meta/terms"
                      target="_blank"
                      className={cx(styles['tc-link'])}
                    >
                      {' '}
                      Terms &amp; Conditions{' '}
                    </a>{' '}
                    and agree to the same
                  </p>
                </div>
              </Fragment>
            ) : null}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default DetailsFields;



// WEBPACK FOOTER //
// ./components/details.tsx